import React from 'react';
import Button from '@alifd/next/lib/button';
import axios from 'axios';
import Upload, { UploadProps } from 'antd/lib/upload/Upload';
import { Message } from '@alifd/next';

const UploadParkingSpaces: React.FC<{ onUpdate: () => void }> = ({
  onUpdate,
}) => {
  const customRequest: UploadProps['customRequest'] = async ({
    file,
    onSuccess,
  }) => {
    const formData = new FormData();
    formData.append('files', file);
    try {
      await axios.post('/ezcon/api/parkingSpacesExcel', formData, {
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
      });
      onUpdate();
      Message.success('上傳成功');
      if (onSuccess) {
        onSuccess(null);
      }
    } catch (error) {
      console.error(error);
      Message.error('上傳失敗');
    }
  };

  return (
    <Upload accept=".xlsx" customRequest={customRequest} showUploadList={false}>
      <Button>匯入車位資料</Button>
    </Upload>
  );
};

export default UploadParkingSpaces;
